import { type AnchorHTMLAttributes, forwardRef } from "react";
import { type LinkProps, Link as RouterLink } from "react-router";

type Props = LinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps>;

export const Link = forwardRef<HTMLAnchorElement, Props>(function Link(props, ref) {
  return <RouterLink ref={ref} {...props} />;
});
